<template>
  <div class="filter-date-style">
    <el-date-picker
      size="mini"
      class="sy-date-editor"
      v-model="timeSet[0]"
      v-bind="$attrs"
      :type="dateType"
      :format="field.dateFormat"
      :valueFormat="$attrs['value-format']"
      :placeholder="pageText.startDate"
      :picker-options="{disabledDate: disabledDate.bind(null, timeSet[1], '>', $attrs.type)}"
      @change="change"
    />
    <span class="sy-list-search-item-separator">{{pageText.to}}</span>
    <el-date-picker
      size="mini"
      class="sy-date-editor"
      v-model="timeSet[1]"
      v-bind="$attrs"
      :type="dateType"
      :format="field.dateFormat"
      :valueFormat="$attrs['value-format']"
      :placeholder="pageText.endDate"
      default-time="23:59:59"
      :picker-options="{disabledDate: disabledDate.bind(null, timeSet[0], '<', $attrs.type)}"
      @change="change"
    />
  </div>
</template>

<script>
  import moment from 'moment'
  import i18n from './i18n.js'
  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'filter-date-between-equal',
    data () {
      return {
        pageText,
        timeSet: ['', '']
      }
    },
    computed: {
      dateType () {
        if (this.$attrs.type) {
          return this.$attrs.type
        }
        if (this.field.dateFormat) {
          const config = {
            'yyyy-MM': 'month',
            'yyyy-MM-dd': 'date',
            'yyyy-MM-dd HH:mm': 'datetime',
            'yyyy-MM-dd HH:mm:ss': 'datetime'
          }
          return config[this.field.dateFormat]
        }
      }
    },
    model: {
      prop: 'values',
      event: 'change'
    },
    props: {
      values: {
        type: Array,
        default: ['', '']
      },
      field: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    watch: {
      values: {
        immediate: true,
        handler (val) {
          let timeSlot = [...val].map(v => v || '')

          // 判断是否为全部未选
          if (!timeSlot.filter(v => v).length) {
            timeSlot = ['', '']
          }
          this.timeSet = timeSlot
        }
      }
    },
    methods: {
      // 获取某一个月的总天数
      getDaysOfMonth (year, month) {
        const date = new Date(year, month, 0)
        return date.getDate()
      },
      change (val) {
        // 筛选时，如果只选择”开始时间“，不选择”结束时间“，筛选大于等于开始时间的数据，包含永久；
        // 筛选时，如果只选择”结束时间“，不选择”开始时间“，筛选小于等于结束时间的数据，包含为空的数据；
        // 如果设置结束时间小于开始时间时，toast提示“结束时间不能小于开始时间”；
        if (this.timeSet[0] && this.timeSet[1] && (new Date(this.timeSet[0]).getTime() > new Date(this.timeSet[1]).getTime())) {
          this.$message.error(this.pageText.endMoreStart)
          this.$set(this.timeSet, [1], '')
          return false
        }
        // if (this.field.type === 'paas-date') {
        //   this.$emit('change', this.timeSet)
        //   return false
        // }
        // && this.field.type !== 'paas-date'
        if (this.dateType === 'month' || (this.dateType === 'date')) {
          if (this.timeSet[1]) {
            let str = 'YYYY-MM-DD 23:59:59'
            const endTime = new Date(this.timeSet[1])
            if (this.dateType === 'month') {
              const selectMLastDay = this.getDaysOfMonth(endTime.getFullYear(), endTime.getMonth() + 1)
              str = `YYYY-MM-${selectMLastDay} 23:59:59`
            }
            this.timeSet[1] = moment(endTime).format(str)
          }
          if (this.timeSet[0]) {
            this.timeSet[0] = moment(this.timeSet[0]).format('YYYY-MM-DD 00:00:00')
          }
        } else {
          if (this.timeSet[0]) {
            this.timeSet[0] = moment(this.timeSet[0]).format('YYYY-MM-DD HH:mm:ss')
          }
          if (this.timeSet[1]) {
            this.timeSet[1] = moment(this.timeSet[1]).format('YYYY-MM-DD HH:mm:ss')
          }
        }
        this.$emit('change', this.timeSet)
      },
      // TODO 暂时有冗余
      disabledDate (refer, action, type = 'timestamp', date) {
        if (!refer) {
          return false
        }
        if (this.dateType === 'datetime' || (this.field.type === 'paas-date' && this.dateType === 'date')) {
          let newDate = refer
          newDate = new Date(newDate).setHours('00')
          newDate = new Date(newDate).setMinutes('00')
          newDate = new Date(newDate).setSeconds('00')
          refer = newDate
        }
        if (action === '>') {
          return new Date(date).getTime() > new Date(refer).getTime()
        } else if (action === '<') {
          return new Date(date).getTime() < new Date(refer).getTime()
        }
        return false
      }
    }
  }
</script>
